import React from 'react';
import {connect} from 'react-redux';

import PropTypes from "prop-types";
import {discountSectionsInterface} from "./discountsInterface";
import TextInput from "../Generic/textInput";
import {setDiscountSections} from "./discountsActions";
import {arrayMove} from "../../utilities";

class DiscountSection extends React.Component {

  state = {
    isDraggedOver: false
  };

  static propTypes = {
    discountSection: PropTypes.shape(discountSectionsInterface)
  };

  setDiscountSectionProperty = (property, value) => {
    const currentDiscountSection = this.props.discountSection;
    currentDiscountSection[property] = value;
    this.updateDiscountSection(currentDiscountSection);
  };

  updateDiscountSection = (currentDiscountSection) => {
    this.props.setDiscountSections(this.props.discountSections.map((discountSection) => {
      if (currentDiscountSection.order === discountSection.order) {
        return currentDiscountSection
      }
      return discountSection
    }));
  };

  onMouseOver = () => {
    // if group is dragged && cat name !== All
    if (window.draggingDiscountSection > -1 && !this.state.isDraggedOver) {
      this.setState({
        isDraggedOver: true
      })
    }
  };

  onMouseLeave = () => {
    if (this.state.isDraggedOver) {
      this.setState({
        isDraggedOver: false
      })
    }
  };

  onHeaderMouseOver = () => {
    // if group is dragged && cat name !== All
    if ((window.draggingDiscountSection > -1 && !this.state.isHeaderDraggedOver)
      && window.draggingDiscountSection !== this.props.discountSection.order) {
      this.setState({
        isHeaderDraggedOver: true
      })
    }
  };

  onHeaderMouseLeave = () => {
    if (this.state.isHeaderDraggedOver) {
      this.setState({
        isHeaderDraggedOver: false
      })
    }
  };

  changeSectionOrder = (shift) => {
    const discountSection = this.props.discountSection;
    const newDiscountSections = arrayMove(this.props.discountSections, discountSection.order, discountSection.order + shift);
    let discountSectionsToUpdate = [];
    newDiscountSections.forEach((currentDiscountSection, currentDiscountSectionIndex) => {
      currentDiscountSection.order = currentDiscountSectionIndex;
      // if ((categoryIndex >= oldIndex) || (categoryIndex >= newIndex)) {
      //   discountsToUpdate.push(discount);
      // }
    });
    this.props.setDiscountSections(newDiscountSections); //update on frontend
  };

  removeSection = () => {
    const newDiscountSections = this.props.discountSections;
    newDiscountSections.splice(this.props.discountSection.order, 1);
    let discountSectionsToUpdate = [];
    newDiscountSections.forEach((currentDiscountSection, currentDiscountSectionIndex) => {
      currentDiscountSection.order = currentDiscountSectionIndex;
      // if ((categoryIndex >= oldIndex) || (categoryIndex >= newIndex)) {
      //   discountsToUpdate.push(discount);
      // }
    });
    this.props.setDiscountSections(newDiscountSections); //update on frontend
  };

  render() {
    const discountSection = this.props.discountSection;
    return (
      <li className={"discounts-section" + (this.state.isDraggedOver ? " discounts-section--dragged-over" : "")}
          onMouseOver={this.onMouseOver}
          onMouseLeave={this.onMouseLeave} data-order={discountSection.order}>
        <div className={"discounts-section__header" + (this.state.isHeaderDraggedOver ? " discounts-section__header--dragged-over" : "")}
             onMouseOver={this.onHeaderMouseOver}
             onMouseLeave={this.onHeaderMouseLeave}>
          <div className="discounts-section__header-name">
            <TextInput className={"discounts-section__header-name-text"}
                       onChange={(value) => this.setDiscountSectionProperty("name", value)}
                       value={this.props.discountSection.name}/>
          </div>
          <div className="discounts-section__header-buttons">
            <button className={"ui-icon-arrow2 ui-icon-arrow2--up" + (discountSection.order === 0 ? " disabled" : "")}
                    onClick={() => discountSection.order ? this.changeSectionOrder(-1) : null}/>
            <button className={"ui-icon-arrow2 ui-icon-arrow2--down" + (discountSection.order === this.props.discountSections.length - 1 ? " disabled" : "")}
                    onClick={() => discountSection.order !== this.props.discountSections.length - 1 ? this.changeSectionOrder(1) : null}/>
            <button className="ui-close ui-close--gray ui-close--small" onClick={this.removeSection}/>
          </div>
        </div>
        <ul className="discounts-section__discounts">
          {this.props.children}
        </ul>
      </li>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    discountSections: store.discountsState.discountSections
  };
};

const mapDispatchToProps = {
  setDiscountSections
};

export default connect(mapStateToProps, mapDispatchToProps)(DiscountSection);
